<!--floorTree-->
<template>
  <div class="left-tree">
    <el-input placeholder="输入层级搜索" v-model="filterText" size="mini"> </el-input>
    <div class="btns">
      <span></span>
      <span class="txt" v-if="flag"> 门禁数 </span>
      <span class="txt" v-else> <span class="i">开启</span>/总数 </span>
    </div>
    <el-scrollbar style="height:calc(100% - 60px);width: 100%;">
      <el-tree :data="getEntityTypeList" default-expand-all :props="defaultProps" :highlight-current='true'
        :filter-node-method="filterNode" ref="tree" @node-click="checkItem">
        <span class="custom-tree-node" slot-scope="{node}">
          <img v-if="node.data.typeEnum == 0" src="../../../assets/imgs/lou.png" />
          <img v-else src="../../../assets/imgs/lou2.png" />
          <span class="tt">{{node.data.typeName }}</span>

          <span class="aaa" v-if="flag">{{node.data.b }}</span>
          <span class="aaa" v-else><span style="font-size: 12px;color: #0D75D4;">{{node.data.a }}</span>/{{node.data.b
            }}</span>
        </span>
      </el-tree>
    </el-scrollbar>
  </div>
</template>
<script>
  import {getReadDeviceTree} from '../../../api/abbNewApi.js'
  export default {

    props: {
      filterText: {
        type: String,
        default: ''
      },
      flag: {
        type: Number,
        default: 0
      },
    },
    data () {
      return {
        getEntityTypeList: this.$store.unitStore.state.getEntityTypeList,
        defaultProps: {
          children: 'children',
          label: 'typeName'
        },
        defaultUnitId: '',
        seconds: 60,
        changeStatus: false,
        nowIndex: -1
      }
    },
    created () {},
    mounted () {

    },
    destroyed () {},
    computed: {
      getResourcesByName () {
        return this.$store.resourcesStore.getters.getResourcesByName
      },
      nowVirtualDevice () {
        return this.$store.deviceStore.state.nowVirtualDevice
      },
      nowDevice () {
        let nowDevice=this.nowVirtualDevice
        if(!isempty(nowDevice)) {
          nowDevice.label=nowDevice.name
        }
        return nowDevice
      },
      defaultDevice () {
        if(isempty(this.nowDevice)) {
          if(!isempty(this.dataList)) {
            this.digui(this.dataList)
          }
        }
        return isempty(this.nowDevice)? '':this.nowDevice.pkid
      },
      dataList () {
        var data=this.$store.unitStore.getters.getUnitTree;
        return isempty(data)? []:[unitList(data)]
      },
      unitList () {
        if(this.dataList.length==0) {
          return []
        }
        return treeToList(this.dataList[0],'children',item => item.hasOwnProperty('children'))
      }
    },
    watch: {
      filterText (val) {
        this.$refs.tree.filter(val);
      },
      dataList (nv,ov) {
        if(!isempty(this.dataList)) {
          this.defaultUnitId=this.dataList[0].id
        }
      },
    },
    methods: {
      filterNode (value,data) {
        if(!value) return true;
        return data.typeName.indexOf(value)!==-1;
      },
      checkItem (value) {
        this.$emit('checkItem',value)
      },
      // 停止自动切换
      stopAutoChange () {
        this.changeStatus=false
        removeTask('autoChangeTimer')
      },
    }
  }
</script>

<style scoped lang="scss">
  .left-tree {
    width: 224px;
    min-height: 100%;
    background-color: #fff;
    margin-right: 8px;
    box-sizing: border-box;
    padding: 12px;
    padding-top: 20px;

    .btns {
      margin-top: 20px;
      color: #1A1A1A;
      font-family: Microsoft YaHei;
      font-weight: regular;
      font-size: 14px;
      display: flex;
      justify-content: space-between;
      cursor: pointer;

      .txt {
        font-family: Microsoft YaHei;
        font-weight: regular;
        font-size: 12px;
        padding-right: 8px;
      }

      .i {
        color: #0D75D4;
        font-family: Microsoft YaHei;
        font-weight: regular;
        font-size: 12px;
      }
    }

    /deep/.el-button {
      padding: 6px 11px !important;
    }
  }
</style>
<style scoped lang="scss">
  .ul {
    display: flex;
    flex-direction: column;
    border: 1px solid #e6e6e6;
    width: 100%;

    .li {
      display: flex;
      border-top: 1px solid #e6e6e6;

      .name {
        color: #1A1A1A;
        font-family: Microsoft YaHei;
        font-weight: regular;
        font-size: 14px;
        width: 44px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 12px;
        background-color: #FBFBFB;
      }

      .box_ul {
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        padding-top: 12px;

        .box_li {
          border-radius: 4px;
          background: #368ED9;
          width: 24px;
          height: 24px;
          margin-right: 12px;
          text-align: center;
          margin-bottom: 12px;
          line-height: 24px;
          color: #fff;
          font-size: 14px;
        }
      }
    }

    .li:nth-child(1) {
      border: none;
    }
  }

  .titles {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 20px;
    margin-bottom: 8px;
    color: #666;
    font-family: Microsoft YaHei;
    font-weight: regular;
    font-size: 12px;

    .l1 {
      border-radius: 4px;
      background: #368ED9;
      width: 24px;
      height: 24px;
      margin-right: 20px;
      text-align: center;
      line-height: 24px;
      color: #fff;
      font-size: 14px;
    }

    .l2 {
      border-radius: 4px;
      background: #E6E6E6;
      width: 24px;
      height: 24px;
      margin-right: 20px;
    }

    .l3 {
      border-radius: 4px;
      background: #FF7A2F;
      width: 24px;
      height: 24px;
      margin-right: 20px;
    }

    .rightd {
      border-radius: 4px;
      background: #FFF;
      border: 1px solid #E6E6E6;
      padding: 2px;
      display: flex;
      align-items: center;
      cursor: pointer;
    }

    .leftd {
      display: flex;
      align-items: center;

      img {
        margin-right: 20px;
      }
    }
  }

  .name-wrapper {
    position: absolute;
    width: 50px;
  }

  .spot img {
    position: absolute;
    width: .5rem;
    height: .5rem;
    left: 0;
    top: 0;
  }

  .center {
    position: relative;
    display: flex;
    flex-wrap: wrap;
  }

  .num_box {
    display: flex;
    border-radius: 4px;
    border: 1px solid #EBEBEB;
    justify-content: space-around;
    margin-top: 20px;
    height: 66px;
    align-items: center;

    .line {
      width: 1px;
      height: 42px;
      background-color: #EBEBEB;
    }

    .num {
      color: #1A1A1A;
      font-family: Microsoft YaHei;
      font-weight: bold;
      font-size: 18px;
      margin-bottom: 2px;
      text-align: center;
    }

    .e {
      color: #666;
      font-family: Microsoft YaHei;
      font-weight: regular;
      font-size: 12px;

    }
  }

  .custom-tree-node {
    display: flex;
    width: calc(100% - 51px);

    .tt {
      padding: 0px 5px;
      color: #1A1A1A;
      font-family: Microsoft YaHei;
      font-weight: regular;
      font-size: 14px;

    }

    .aaa {
      flex: 1;
      display: flex;
      justify-content: flex-end;
      font-family: Microsoft YaHei;
      font-weight: regular;
      font-size: 12px;
      align-items: center;
    }
  }

  .archiverstype {
    .con {
      width: 100%;
      min-height: 100%;
      box-sizing: border-box;
      display: flex;
      padding: 8px;


      .public-flex {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .right-table {
        width: calc(100% - 232px);
        min-height: 100%;
        background-color: #fff;
        box-sizing: border-box;
        padding: 20px;


      }
    }
  }
</style>
<style>
  .el-scrollbar__wrap {
    overflow: auto;
  }

  .el-popover {
    padding: 0 !important;
    border-radius: 4px;
    overflow: hidden;
  }
</style>